import { Card, Space, Table } from "@arco-design/web-react";
import { useCallback, useEffect, useState } from "react";
import { ItemReceiptAPI } from "@/apis/purchasing";
import { POReceiptStatusDef } from "@/enums/purchasing";
import { EnumLabel, EnumSelect } from "@/components/Enum";
import { Link } from "react-router-dom";
import { ReceiptInfo } from "./receipt-info";
import { ReceiptAdd } from "./receipt-add";
import { ReceiptEdit } from "./receipt-edit";

export const Receipt = () => {
    const [status, setStatus] = useState(null);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);

    const getReceipts = useCallback(async () => {
        const values = await ItemReceiptAPI.query(page, { status: status });
        setData(values.records);
        setTotal(values.total);

    }, [page, status]);

    useEffect(() => {
        getReceipts();
    }, [getReceipts]);


    return (
        <Card title="Item Receipts" extra={
            <Space>
                <EnumSelect enumObj={POReceiptStatusDef} allowAll
                    value={status}
                    placeholder="Status" style={{ width: 200 }}
                    onChange={(val) => {
                        setStatus(val);
                    }} />

            </Space>
        }>
            <Table rowKey="id"
                columns={[
                    {
                        title: "Item Receipt#",
                        render: (col, record, index) =>
                            <Link to={"/workspace/purchasing/receipt/" + record.id}>{record.receiptNo}</Link>
                    },
                    { title: "PO#", dataIndex: "poNo" },
                    { title: "Status", dataIndex: "status", render: (col, record) => <EnumLabel enumObj={POReceiptStatusDef} value={record.status} /> },
                    { title: "Vendor", dataIndex: "vendorName" },
                    { title: "Receive Date", dataIndex: "receiveDate" },
                ]}
                pagination={{ total, current: page }}
                data={data}
                onChange={(pagination) => setPage(pagination.current)}
            />
        </Card>
    );
}

Receipt.Info = ReceiptInfo;
Receipt.Add = ReceiptAdd;
Receipt.Edit = ReceiptEdit;
